<div class="z-card z-rise filter-card">
  <div class="filter-grid">

    @for (field of fields; track field.key) {
      <fieldset class="z-fieldset filter-field"
                [class.z-fieldset--plain]="field.plain"
                [class.filter-field--wide]="field.type === 'range'">
        <legend>{{ field.label }}</legend>

        @if (field.type === 'range') {
          <div class="z-select range">
            <span class="z-select-placeholder">{{ field.placeholder || 'Rango' }}</span>
            <i class="bi bi-caret-down-fill caret" aria-hidden="true"></i>
          </div>
        } @else {
          <app-multi-select
            [attr.data-field-label]="field.label"
            [options]="field.options"
            [selected]="value[field.key] || []"
            [multiple]="field.type === 'multi'"
            [placeholder]="field.placeholder || 'TODOS'"
            (selectedChange)="onChange(field.key, $event)" />
        }
      </fieldset>
    }

  </div>

  <div class="filter-actions">
    <button class="z-btn z-btn--purple" type="button" (click)="apply()">
      <span class="bullet" aria-hidden="true"></span>Aplicar Filtros
    </button>
    <button class="z-btn z-btn--glass" type="button" (click)="clear()">
      <span class="bullet" aria-hidden="true"></span>Limpiar Filtros
    </button>
  </div>
</div>
